import { createContext } from 'react';

/**
 * @type {React.Context<{
 *  field: {
 *    currentPassword: string;
 *    newPassword: string;
 *    confirmPassword: string;
 *  };
 *  visibility: {
 *    currentPassword: boolean;
 *    newPassword: boolean;
 *    confirmPassword: boolean;
 *  };
 *  error: {
 *    has: boolean;
 *    reason: string;
 *    message: string;
 *  };
 *  rulesValidation: Map<string, boolean>;
 *  changePasswordAPI: {
 *    data: {};
 *    called: boolean;
 *    loading: boolean;
 *  };
 *  handleChange: () => void;
 *  handleChangeVisibility: () => void;
 *  handleSubmit: () => void;
 * }>}
 */
export const ChangePasswordContext = createContext({
});

export const ChangePasswordProvider = ChangePasswordContext.Provider;
